// Type declarations for gtag
declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

export function initGA() {
  if (!GA_MEASUREMENT_ID) return;

  // Set up dataLayer and gtag shim before loading script
  window.dataLayer = window.dataLayer || [];
  // Must use `arguments` (not rest params) — gtag.js expects Arguments objects in the queue
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);

  // Load gtag script after shim is ready
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);
}

export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
}

// Specific event helpers
export const analytics = {
  ctaBookDemo: () => trackEvent("cta_click_book_demo"),
  ctaHowItWorks: () => trackEvent("cta_click_how_it_works"),
  ctaContact: (location: string) => trackEvent("cta_click_contact", { location }),
  formStart: (formName: string) => trackEvent("form_start", { form_name: formName }),
  formSubmit: (formName: string) => trackEvent("form_submit", { form_name: formName }),
  scrollDepth: (percent: number) => trackEvent("scroll_depth", { percent }),
};
